var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "parent" }, [
        _c("img", {
          staticClass: "red_package",
          attrs: { src: require("../../../static/images/alipay/03_11.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "get_red_package",
          attrs: {
            id: "icon",
            src: require("../../../static/images/alipay/icon_03.png")
          },
          on: { click: _vm.getTickt }
        })
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "title",
        attrs: { src: require("../../../static/images/alipay/01_03.png") }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "btn",
        attrs: { src: require("../../../static/images/alipay/02_07.png") },
        on: { click: _vm.goMini }
      }),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("img", {
        staticClass: "logoIcon",
        attrs: { src: require("../../../static/images/tips/03_11.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddcc4950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddcc4950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/alipay.vue
// module id = null
// module chunks = 